import { Component } from '@angular/core';
import type { ICellRendererComp } from 'ag-grid-community';
import type { ActionItemRendererParams, ActionItem } from '../interfaces/ag-grid-cell-renderer.interface';

@Component({
  selector: 'app-ag-quick-actions-cell-renderer',
  templateUrl: './ag-quick-actions-cell-renderer.component.html',
  styleUrls: ['./ag-quick-actions-cell-renderer.component.scss'],
  standalone: false
})

export class AgQuickActionsCellRendererComponent implements ICellRendererComp {
  eGui: HTMLDivElement;

  private params: ActionItemRendererParams;

  rowData: any;
  quickActionItems: ActionItem[] = [];
  
  agInit(params: ActionItemRendererParams): void {
    this.params = params;
    this.rowData = params.data as any;
    this.quickActionItems = params.getActionItems ? params.getActionItems(this.params) : [];
  }

  refresh(params: ActionItemRendererParams): boolean {
    this.params = params;
    this.rowData = params.data as any;
    this.quickActionItems = params.getActionItems ? params.getActionItems(this.params) : [];
    
    return true;
  }

  getGui() {
    return this.eGui;
  }
  
  onActionItemClick(actionItem: ActionItem): void {
    actionItem.callback(this.rowData, this.params, actionItem);
  }
  
  ngOnDestroy(): void {}
}

